"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as o } from "react";
import m from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ a(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.294 3.234c-.574 0-1.06.614-1.06 1.342v14.847c0 .728.486 1.342 1.06 1.342h12.711c.574 0 1.06-.614 1.06-1.342V4.576c0-.728-.486-1.342-1.06-1.342zM18.005 22H5.294C4.029 22 3 20.844 3 19.423V4.576C3 3.155 4.029 2 5.294 2h12.711c1.265 0 2.294 1.155 2.294 2.576v14.847c0 1.421-1.029 2.577-2.294 2.577M16.863 7.925h-5.629a.617.617 0 0 1 0-1.234h5.63a.617.617 0 1 1 0 1.234m-10.083.6a.614.614 0 0 0 .874.002l1.564-1.564a.619.619 0 0 0-.874-.873L7.217 7.218l-.345-.345a.617.617 0 0 0-.874.87zm10.083 8.783h-5.629a.617.617 0 0 1 0-1.234h5.63a.617.617 0 1 1 0 1.234m-10.083.6a.614.614 0 0 0 .874.001l1.564-1.564a.619.619 0 0 0-.874-.873L7.217 16.6l-.345-.345a.617.617 0 0 0-.874.871zm10.083-5.291h-5.629a.617.617 0 0 1 0-1.234h5.63a.617.617 0 1 1 0 1.234m-10.083.6a.614.614 0 0 0 .874.001l1.564-1.564a.619.619 0 0 0-.874-.873L7.22 11.909l-.345-.345a.617.617 0 0 0-.874.871z",
        clipRule: "evenodd"
      }
    )
  }
), i = o(t);
export {
  i as Lists,
  i as default
};
